
/**
 * Custom component for Christmas drink items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.1
 * @copyright  Copyright (C) 2024-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2024-12-13 (1.0.0) (jhoward)
 *      - <christmasFoodItem> copied to <christmasDrinkItem>.
 *
 *    2025-04-08 (1.0.1) (jhoward)
 *      - Remove "visual_" prefix from class names in <christmasDrinkItem>.
 */

import {defineComponent, PropType} from "vue";
import {MenuItem} from "../defs";
import DefaultItem from "./defaultItem.vue";

export default defineComponent({
  name: 'christmas-drink-item',
  components: {
    DefaultItem
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
    pricingTypes: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    priceLayout: {
      type: String as PropType<'price-inline' | 'price-below'>,
      default: 'price-inline'
    }
  },
})
